import { createRoot } from "react-dom/client";
import ROOT from "constants/app-root";
import App from "./App";

const container = document.getElementById(ROOT);
const root = createRoot(container);
root.render(<App />);
